<template>
  <div class="relative">
    <div
      v-show="!hideLabel"
      class="px-1 pb-0.5 text-xs"
      :class="{
        'text-red-600': error
      }"
    >
      {{ name }}
    </div>
    <div
      class="blockp text-field relative rounded-md border border-cdp-grey-400 bg-white px-2 py-2 text-sm text-cdp-black-500 duration-300 focus:border-cdp-black-500 focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:bg-cdp-black-100/50 disabled:text-cdp-grey-500"
    >
      <v-field
        :ref="textField"
        v-model="inputVal"
        :name="name"
        :rules="rules"
        :disabled="disabled"
        :type="textFieldType"
        autocomplete="off"
        class="h-full w-full rounded-sm bg-transparent outline-none"
        :class="{
          'border-red-600 focus:border-red-600': error
        }"
        :placeholder="placeholder"
        @focus="toFocus"
        @blur="toBlur"
        @chang="changeVal"
      />
      <icon
        v-if="type === 'password'"
        :name="doesShowPassword ? 'ic_common_eys_on' : 'ic_common_eys_off'"
        class="absolute right-2 top-1/2 h-full w-7 grow-0 -translate-y-1/2 transform cursor-pointer bg-white pl-2"
        @click="onTogglePasswordVisibility"
      />
    </div>
    <v-error-message :name="name" class="ml-2 text-xs text-red-600" />
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate';
import { ref, computed, defineComponent } from 'vue';

export default defineComponent({
  /**
   * 最初註冊名稱與檔案名稱開頭大小寫不一致，故針對此命名（Histoire 讀檔用）
   */
  name: 'TextField',
  components: {
    'v-field': Field,
    'v-error-message': ErrorMessage
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'type'
    },
    placeholder: {
      type: String,
      default: ' '
    },
    rules: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: undefined
    },
    hideLabel: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'change', 'focus', 'blur'],
  setup(props, { emit }) {
    const textField = ref(null);
    const doesShowPassword = ref(false);
    const inputVal = computed({
      get: () => props.modelValue,
      set: (val) => {
        emit('update:modelValue', val);
      }
    });

    const textFieldType = computed(() => {
      return props.type === 'password' && doesShowPassword.value ? 'text' : props.type;
    });

    function changeVal() {
      emit('change', props.modelValue);
    }

    function toFocus() {
      emit('focus', props.modelValue);
    }

    function toBlur() {
      emit('blur', props.modelValue);
    }

    function setFoucs() {
      textField.value.focus();
    }

    function onTogglePasswordVisibility() {
      doesShowPassword.value = !doesShowPassword.value;
    }

    return {
      inputVal,
      textField,
      doesShowPassword,
      textFieldType,
      changeVal,
      toFocus,
      toBlur,
      setFoucs,
      onTogglePasswordVisibility
    };
  }
});
</script>